import { EndpointModulesStatusDetailsController } from '../controller/EndpointModulesStatusDetailsController';
import { BaseWidgetWebComponent } from '../../../widget/BaseWidgetWebComponent';

export class EndpointModulesStatusDetailsWebComponent extends BaseWidgetWebComponent {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EndpointModulesStatusDetailsController,
    });
  }
}
